import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import logo from "@/assets/EMA-KO-Logo.png";

const ProductPhotos = () => {
  useEffect(() => {
    const scriptSrc = "https://cdn.commoninja.com/sdk/latest/commonninja.js";
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Navbar />

      {/* Hero */}
      <section className="flex flex-col items-center justify-center text-center pt-8 pb-5 bg-black">
        <h1 className="text-4xl md:text-[4rem] font-bold text-section-dark-foreground mb-4">
          photo portfolio
        </h1>
      </section>

      {/* Content */}
      <section className="bg-white px-4 md:px-12 py-0 space-y-5 pb-[50px] pt-[50px]">
        <div className="max-w-6xl mx-auto space-y-5 pb-0">
          {/* 1. Photo Slider */}
          <div className="commonninja_component pid-b50c9c2e-e36b-4746-80c7-c6db421a97b5"></div>

          {/* 2. Photo Gallery 1 */}
          <div className="commonninja_component pid-c97ab087-8762-471a-948e-48bc09bd48bb"></div>

          {/* 3. Photo Gallery 2 */}
          <div className="mb-2 commonninja_component pid-22806446-a693-418b-b532-58d33d66987d"></div>

          {/* 4. Side by side Canva embeds */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-4">
            <div style={{ position: "relative", width: "100%", height: 0, paddingTop: "100%", overflow: "hidden", borderRadius: 8, willChange: "transform", boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)" }}>
              <iframe
                loading="lazy"
                style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, border: "none", padding: 0, margin: 0 }}
                src="https://www.canva.com/design/DAGwLWRdGE0/mbNTmcKj9hqzRHynhFvc9Q/view?embed"
                allowFullScreen
                allow="fullscreen"
              />
            </div>
            <div style={{ position: "relative", width: "100%", height: 0, paddingTop: "100%", overflow: "hidden", borderRadius: 8, willChange: "transform", boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)" }}>
              <iframe
                loading="lazy"
                style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, border: "none", padding: 0, margin: 0 }}
                src="https://www.canva.com/design/DAF1koc1jC0/view?embed"
                allowFullScreen
                allow="fullscreen"
              />
            </div>
          </div>
          <p className="text-center text-muted-foreground text-base mt-2 mb-4">click images to scroll right →</p>

          {/* 5. Single Canva embed */}
          <div style={{ position: "relative", width: "100%", height: 0, paddingTop: "61.8557%", overflow: "hidden", borderRadius: 8, willChange: "transform", boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)" }}>
            <iframe
              loading="lazy"
              style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, border: "none", padding: 0, margin: 0 }}
              src="https://www.canva.com/design/DAF1l-Z5dgg/view?embed"
              allowFullScreen
              allow="fullscreen"
            />
          </div>
          <p className="text-center text-muted-foreground text-base mt-2">click images to scroll right →</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductPhotos;
